let lenisInstance = null;

export const setLenis = (lenis) => {
  lenisInstance = lenis;
};

export const stopLenis = () => lenisInstance?.stop();

export const startLenis = () => lenisInstance?.start();

export const scrollToId = (selector) => {
  const el = document.querySelector(selector);
  if (!el) return;
  if (lenisInstance) {
    lenisInstance.scrollTo(el, { duration: 1.5, offset: 0 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
